import isArray from "lodash/fp/isArray";
import isObject from "lodash/fp/isObject";
import mapValues from "lodash/fp/mapValues";

export default function nestedObjectReplaceValues(substr, newSubstr) {
  function doNestedObjectReplaceValues(value) {
    if (typeof value === "string") {
      return value.replace(substr, newSubstr);
    }

    if (isArray(value)) {
      return value.map(doNestedObjectReplaceValues);
    }

    if (isObject(value)) {
      return mapValues(doNestedObjectReplaceValues)(value);
    }

    return value;
  }

  return doNestedObjectReplaceValues;
}
